import React, { Dispatch } from "react";
import { useSelector } from "react-redux";
import { actionCreators, getStageInspectionModules } from "../../../../../../../core/actions/configurator-actions";
import { IStore } from "../../../../../../../core/store";
import { strings } from "../../../../../../../localization/strings";
import { ParameterItem } from "../../../../components/ParameterItem";
import { InspectionUISettingsPivot } from "../../settings/InspectionUISettingsPivot";
import { IInterviewConfig, InterviewModes, ProcessStages } from "@piceasoft/core";

type TProps = {
    index: number
    stage: ProcessStages
    onChangeDispatch: Dispatch<any>
}

export const InterviewUISettingsPivot: React.FC<TProps> = (props) => {
    const config = useSelector((s: IStore) => getStageInspectionModules(props.stage, s)?.find(i => i.index === props.index)?.config as IInterviewConfig)
    const isList = InterviewModes.List === config.mode;

    return (
        <InspectionUISettingsPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch}>
            <ParameterItem title={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.DESCRIPTION_TITLE}
                useToggle
                toggleEnabled
                toggleChecked={config.config.ui?.description !== undefined ? true : false}
                toggleOnChange={() => {
                    props.onChangeDispatch(actionCreators.inspections.interview.editInterview(props.stage, props.index, {
                            ...config,
                            config: {
                                ...config.config,
                                ui: {
                                    ...config.config.ui,
                                    description: config.config.ui?.description !== undefined ? undefined : ""
                                }
                            }
                    }))
                }}
                description={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.DESCRIPTION_DESCRIPTION}
                useTextField
                textFieldMultiLimitSymbolsCount={40}
                textFieldEnabled={config.config.ui?.description !== undefined ? true : false}
                textFieldValue={config.config.ui?.description}
                textFieldOnChange={(val) => props.onChangeDispatch(actionCreators.inspections.interview.editInterview(props.stage, props.index, {
                    ...config,
                    config: {
                        ...config.config,
                        ui: {
                            ...config.config.ui,
                            description: val
                        }
                    }
                })
                )}
            />
            {!isList && (
                <ParameterItem title={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.REJECT_TITLE}
                    useToggle
                    toggleEnabled
                    toggleChecked={config.config.ui?.reject !== undefined ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.inspections.interview.editInterview(props.stage,props.index, {
                                ...config,
                                config: {
                                    ...config.config,
                                    ui: {
                                        ...config.config.ui,
                                        reject: config.config.ui?.reject !== undefined ? undefined : ""
                                    }
                                }
                        }))
                    }}
                    description={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.REJECT_DESCRIPTION}
                    useTextField
                    textFieldMultiLimitSymbolsCount={40}
                    textFieldEnabled={config.config.ui?.reject !== undefined ? true : false}
                    textFieldValue={config.config.ui?.reject}
                    textFieldOnChange={(val) => props.onChangeDispatch(actionCreators.inspections.interview.editInterview(props.stage,props.index, {
                        ...config,
                        config: {
                            ...config.config,
                            ui: {
                                ...config.config.ui,
                                reject: val
                            }
                        }
                    })
                    )}
                />
            )}
        </InspectionUISettingsPivot>

    )
}